import { render, staticRenderFns } from "./index.vue?vue&type=template&id=726bd87c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./treatment-step-three.scss?vue&type=style&index=0&id=726bd87c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726bd87c",
  null
  
)

export default component.exports